import { PackageType } from '@retail/products/types';
import { PriceType } from '../Conditions';
import { dateFromString } from '@retail/utils';
import { ConditionBindingMinimal, PurchaseConditionDTO } from '../../dtos/ConditionsNewDTO';

interface PurchaseConditionProps {
  conditionId: number;
  isInherited: boolean;
  inheritedBinding?: ConditionBindingMinimal;
  isDeletionCondition: boolean;
  agreementId: number;
  agreementText?: string;
  agreementNumber?: string;
  priceType?: PriceType;
  packageType?: PackageType;
  validFrom: Date;
  validTo?: Date;
}

export class PurchaseConditionNew {
  conditionId: number;
  isInherited: boolean;
  inheritedBinding?: ConditionBindingMinimal;
  isDeletionCondition: boolean;
  agreementId: number;
  agreementText?: string;
  agreementNumber?: string;
  priceType?: PriceType;
  packageType?: PackageType;
  validFrom: Date;
  validTo?: Date;

  constructor({
    conditionId,
    isInherited,
    inheritedBinding,
    isDeletionCondition,
    agreementId,
    agreementText,
    agreementNumber,
    priceType,
    packageType,
    validFrom,
    validTo,
  }: PurchaseConditionProps) {
    this.conditionId = conditionId;
    this.isInherited = isInherited;
    this.inheritedBinding = inheritedBinding;
    this.isDeletionCondition = isDeletionCondition;
    this.agreementId = agreementId;
    this.agreementText = agreementText;
    this.agreementNumber = agreementNumber;
    this.priceType = priceType;
    this.packageType = packageType;
    this.validFrom = validFrom;
    this.validTo = validTo;
  }

  static fromDto = (dto: PurchaseConditionDTO): PurchaseConditionNew =>
    new PurchaseConditionNew({
      conditionId: dto.conditionId,
      isInherited: dto.isInherited,
      inheritedBinding: dto.inheritedBinding,
      isDeletionCondition: dto.isDeletionCondition,
      agreementId: dto.agreementId,
      agreementText: dto.agreementText,
      agreementNumber: dto.agreementNumber,
      priceType: dto.priceType,
      packageType: dto.packageType,
      validFrom: new Date(dto.validFrom),
      validTo: dateFromString(dto.validTo),
    });
}
